import { breakpoints, theme } from '../constants';
import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/Divider' {
  interface DividerPropsVariantOverrides {
    extended: true;
  }
}

const Divider: ThemeOptions['components'] = {
  MuiDivider: {
    variants: [
      {
        props: { variant: 'extended' },
        style: {
          marginLeft: theme.spacing(2 * -1),
          marginRight: theme.spacing(2 * -1),

          [breakpoints.up('md')]: {
            marginLeft: theme.spacing(3 * -1),
            marginRight: theme.spacing(3 * -1),
          },
        },
      },
    ],
  },
};

export default Divider;
